module.exports = __webpack_public_path__ + "img/typicons.cae8fddf.svg";